import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import { useMainStore } from '@/pinia';
const store = useMainStore();

// @ts-ignore: Unreachable code error
export const userId = store.userInfo.userId; // 条件性访问

export const driverTypeStorage = {
  init() {
    const initialData = { userId: '', driverTypes: [] };
    const existingData = JSON.parse(localStorage.getItem('driverTypesList') as string) || [];

    // 如果还没有用户数据或者结构不正确，进行初始化
    if (!existingData.length || !Array.isArray(existingData)) {
      localStorage.setItem('driverTypesList', JSON.stringify([initialData]));
    }
  },

  save(driverType) {
    let driverTypesList = JSON.parse(localStorage.getItem('driverTypesList') as string) || [];

    // 查找对应用户的记录
    const userIndex = driverTypesList.findIndex((user) => user.userId === userId);

    if (userIndex !== -1) {
      // 如果用户已存在，检查并添加driverType（避免重复）
      const userDriverTypes = driverTypesList[userIndex].driverTypes;
      if (!userDriverTypes.includes(driverType)) {
        userDriverTypes.push(driverType);
        driverTypesList[userIndex].driverTypes = userDriverTypes;
      }
    } else {
      // 用户不存在，创建新记录
      driverTypesList.push({ userId, driverTypes: [driverType] });
    }

    localStorage.setItem('driverTypesList', JSON.stringify(driverTypesList));
  },

  exists(driverTypeToCheck) {
    const driverTypesList = JSON.parse(localStorage.getItem('driverTypesList') as string) || [];
    const user = driverTypesList.find((user) => user.userId === userId);

    return user && user.driverTypes.includes(driverTypeToCheck);
  },

  getAllForUser() {
    const driverTypesList = JSON.parse(localStorage.getItem('driverTypesList') as string) || [];
    const user = driverTypesList.find((user) => user.userId === userId);

    return user ? user.driverTypes : [];
  },

  remove(driverTypeToRemove) {
    let driverTypesList = JSON.parse(localStorage.getItem('driverTypesList') as string) || [];
    const userIndex = driverTypesList.findIndex((user) => user.userId === userId);

    if (userIndex !== -1) {
      const updatedDriverTypes = driverTypesList[userIndex].driverTypes.filter((type) => type !== driverTypeToRemove);
      if (updatedDriverTypes.length) {
        // 只有当driverTypes非空时才更新，否则移除该用户记录
        driverTypesList[userIndex].driverTypes = updatedDriverTypes;
      } else {
        driverTypesList.splice(userIndex, 1);
      }

      localStorage.setItem('driverTypesList', JSON.stringify(driverTypesList));
    }
  },

  clearAll() {
    localStorage.removeItem('driverTypesList');
    // 或者初始化为空数组，取决于你的具体需求
    // localStorage.setItem('driverTypesList', JSON.stringify([]));
  },
};

// 首页
export function workPlateformDriver() {
  // let driverType = 'workPlateformDriver';
  // const driverObj = driver({
  //   onDestroyed: () => {
  //     driverTypeStorage.save(driverType);
  //   },
  // });
  // const quickCreation = () => {
  //   driverObj.highlight({
  //     element: '#quick-creation',
  //     popover: { title: '指引提示', description: '点击 “快速创建” 海量形象一键生成', side: 'left', align: 'start' },
  //   });
  // };

  // onUnmounted(() => {
  //   driverObj.destroy();
  // });

  // return { quickCreation, driverType };
}

// 创建
export function newVideoDriver() {
  // 数字人形象功能
  const driverObj = driver();
  let driverType = 'newVideoDriver';
  const szrMan = () => {
    driverObj.setConfig({
      showProgress: true,
      doneBtnText: '了解',
      nextBtnText: '下一步',
      prevBtnText: '上一步',
      steps: [
        {
          element: '#digital-man',
          popover: { title: '指引提示', description: '选择您喜欢的数字人形象', side: 'left', align: 'start' },
        },
        {
          element: '#no-text',
          popover: { title: '指引提示', description: '点击此处可为您生成提示词模板', side: 'left', align: 'start' },
        },
        {
          element: '#create-article',
          popover: { title: '指引提示', description: '一键生成AI文案', side: 'left', align: 'start' },
        },
        {
          element: '#timbre-setting',
          popover: { title: '指引提示', description: '选择您喜欢的音色', side: 'left', align: 'start' },
        },
        { element: '#craft-video', popover: { title: '指引提示', description: '合成视频', side: 'left', align: 'start' } },
      ],
      onDestroyed: () => {
        driverTypeStorage.save(driverType);
      },
    });
    driverObj.drive();
  };

  onUnmounted(() => {
    driverObj.destroy();
  });
  return { szrMan, driverType };
}

// 互动问答库
export function chatBaseDriver() {
  // 数字人形象功能
  const driverObj = driver();
  let driverType = 'chatBaseDriver';
  const chatBaseDriverFn = () => {
    driverObj.setConfig({
      showProgress: true,
      doneBtnText: '了解',
      nextBtnText: '下一步',
      prevBtnText: '上一步',
      steps: [
        {
          element: '#add-knowledge-btn',
          popover: { title: '指引提示', description: '添加您的知识库', side: 'left', align: 'start' },
        },
        {
          element: '#add-knowledge-upload',
          popover: { title: '指引提示', description: '上传知识库文档', side: 'left', align: 'start' },
        },
      ],
      onDestroyed: () => {
        driverTypeStorage.save(driverType);
      },
    });
    driverObj.drive();
  };

  onUnmounted(() => {
    driverObj.destroy();
  });

  return { chatBaseDriverFn, driverType };
}

// 图片转视频
export function imgDigitalAvatarDriver() {
  const driverObj = driver();
  let driverType = 'imgDigitalAvatarDriver';

  const startGuide = () => {
    driverObj.setConfig({
      showProgress: true,
      doneBtnText: '了解',
      nextBtnText: '下一步',
      prevBtnText: '上一步',
      steps: [
        {
          element: '.upload-trigger',
          popover: {
            title: '第一步',
            description: `
      <div class="guide-container">
        <div class="guide-text">
          <i class="guide-icon">🖼️</i>
          <p>上传一张照片，请注意：</p>
          <ul>
            <li>照片类型：肖像或半身照正视图最佳，全身照亦可。</li>
            <li>清晰度要求：五官清晰可见。</li>
            <li>注意事项：脸部比例越小，数字人生成失败概率越大，因为脸部信息是数字人构建关键部分，较小比例可能导致关键特征捕捉不足，影响生成质量和准确性，所以选照片时应保证脸部有足够占比和清晰度。</li>
          </ul>
        </div>
        <div class="guide-image">
          <img 
            src="https://virtualhuman-cos-test-1251316161.cos.ap-nanjing.myqcloud.com/prod/resource-manager/small/903/10561/10613/model_16594_20240321160803/preview.png"
            style="
              width: 100%;
              height: 250px;
              object-fit: contain;
              border-radius: 8px;
              margin-top: 12px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            "
            alt="示例图片"
          />
        </div>
        <style>
          .guide-container {
            padding: 12px 0;
            box-sizing: border-box;
          }
          .guide-text {
            color: #333;
            line-height: 1.5;
          }
          .guide-text ul {
            margin: 8px 0;
            padding-left: 20px;
          }
          .guide-text li {
            margin: 4px 0;
            font-size: 14px;
          }
          .guide-icon {
            font-size: 20px;
            margin-right: 8px;
          }
        </style>
      </div>
    `,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.name-input-area',
          popover: {
            title: '第二步',
            description: '为生成的视频取个名字',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.input-area',
          popover: {
            title: '第三步',
            description: '选择输入方式并录入需要播报的内容',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.preview-section',
          popover: {
            title: '第四步',
            description: '查看生成的数字人视频效果',
            side: 'left',
            align: 'start',
          },
        },
      ],
      onDestroyed: () => {
        driverTypeStorage.save(driverType);
      },
    });
    driverObj.drive();
  };

  onUnmounted(() => {
    driverObj.destroy();
  });

  return { startGuide, driverType };
}

// 视频转视频引导
export const videoToVideoGuide = require('@/assets/data/videoToVideoDriver.mp4');
export function videoToVideoDriver() {
  const driverObj = driver();
  let driverType = 'videoToVideoDriver';

  const startGuide = () => {
    driverObj.setConfig({
      showProgress: true,
      doneBtnText: '了解',
      nextBtnText: '下一步',
      prevBtnText: '上一步',
      steps: [
        {
          element: '.upload-trigger',
          popover: {
            title: '第一步',
            // description: '上传一段视频，将用于生成数字人视频',
            description: `
            <div class="guide-container">
              <div class="guide-text">
                <i class="guide-icon">📹</i>
                <p>上传一段视频，请注意：</p>
                <ul>
                  <li>时长要求：20-30秒</li>
                  <li>画面要求：人物需全程出现</li>
                  <li>动作要求：可小幅度动作</li>
                  <li>特别注意：人物嘴部需保持静止</li>
                </ul>
              </div>
              <div class="guide-video">
                <video 
                  controls
                  src="${videoToVideoGuide}"
                  style="
                    width: 100%;
                    height: 250px;
                    border-radius: 8px;
                    margin-top: 12px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                  ">
                </video>
              </div>
              <style>
                .guide-container {
                  padding: 12px 0;
                  box-sizing: border-box;
                }
                .guide-text {
                  color: #333;
                  line-height: 1.5;
                }
                .guide-text ul {
                  margin: 8px 0;
                  padding-left: 20px;
                }
                .guide-text li {
                  margin: 4px 0;
                  font-size: 14px;
                }
                .guide-icon {
                  font-size: 20px;
                  margin-right: 8px;
                }
              </style>
            </div>
          `,
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.name-input-area',
          popover: {
            title: '第二步',
            description: '为生成的视频取个名字',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.input-area',
          popover: {
            title: '第三步',
            description: '选择输入方式并录入需要播报的内容',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.preview-section',
          popover: {
            title: '第四步',
            description: '查看生成的数字人视频效果',
            side: 'left',
            align: 'start',
          },
        },
      ],
      onDestroyed: () => {
        driverTypeStorage.save(driverType);
      },
    });
    driverObj.drive();
  };

  onUnmounted(() => {
    driverObj.destroy();
  });

  return { startGuide, driverType };
}
